export default __webpack_public_path__ + "static/calidad-de-la-investigacion-mobile-316309e7efed43ece348ff263056c283.svg";